import { ElementType, ComponentPropsWithoutRef } from "react";
import clsx from "clsx";
import styles from "./Container.module.css";

type ContainerProps<T extends ElementType = "section"> = {
  as?: T;
  children?: React.ReactNode;
  className?: string;
  variant?: 'default' | 'full';
} & ComponentPropsWithoutRef<T>;

export const Container = <T extends ElementType = "section">({
  as,
  children,
  className,
  variant = 'default',
  ...props
}: ContainerProps<T>) => {
  const Component = as || "section";

  return (
    <Component className={clsx(styles.container, styles[variant], className)} {...props}>
      {children}
    </Component>
  );
};
